/**
 * Maps a Canadian province/territory name (as it appears in CA.txt admin1name
 * AND must appear in your provinces geojson's regionNameProperty) to its
 * sliced FSA-polygon file.
 *
 * Files were produced from StatCan 2021 Census FSA cartographic boundaries
 * (lfsa000b21a_e), reprojected EPSG:3347 -> WGS84, simplified, split by PRUID,
 * then renamed by province code. Each feature has:
 *   - CFSAUID : the FSA code, e.g. "M5V"  -> use as postcodeProperty
 *   - PRUID   : province numeric code
 *
 * File extension is .geojson here; if your staging nginx still serves .geojson
 * as text/html (the old MIME bug), use .json instead and adjust the loader.
 *
 * NOTE: NT and NU intentionally use the non-standard names that appear in your
 * CA.txt ("Northwest Territory", "Nunavut Territory") so the FSA dots and the
 * FSA polygons resolve to the SAME region string. If your provinces geojson
 * uses the official "Northwest Territories" / "Nunavut", either rename there or
 * add aliases here.
 */
export const CANADA_PROVINCE_FILES: Record<string, string> = {
  'Newfoundland and Labrador': 'fsa-NL',
  'Prince Edward Island': 'fsa-PE',
  'Nova Scotia': 'fsa-NS',
  'New Brunswick': 'fsa-NB',
  Québec: 'fsa-QC',
  Ontario: 'fsa-ON',
  Manitoba: 'fsa-MB',
  Saskatchewan: 'fsa-SK',
  Alberta: 'fsa-AB',
  'British Columbia': 'fsa-BC',
  Yukon: 'fsa-YT',
  'Northwest Territories': 'fsa-NT',
  Nunavut: 'fsa-NU',
};
